import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import useStateCallback from "../../util/customHooks/useStateCallback";
import ajaxFuelCategories from "../../util/remote/ajaxFuelCategories";
import RegisterFuelCategoryModal from "./RegisterFuelCategoryModal";
import UpdateFuelCategory from "./UpdateFuelCategory";
const ViewFuelCategories = () => {
  const station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [Fuel_categories, setFuel_categories] = useState([]);
  const [viewType, setViewType] = useState("table view");
  const [station_id, setstation_id] = useState(station_idd);
  // Fetch Station Owners
  const fetchFuel_categories = async () => {
    setLoading(true);
    const data = {
      station_id: station_id,
    };
    const response = await ajaxFuelCategories.list_fuel_categories(data);
    if (response.status === "OK") {
      setFuel_categories(response.details || []);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchFuel_categories();
  }, [station_id]);
  const toggleView = (type) => setViewType(type);
  const [update, setUpdate] = useStateCallback(false);
  const handleViewDetails = (owner) => {
    setUpdate(false, () =>
      setUpdate(<UpdateFuelCategory data={owner} func={fetchFuel_categories} />)
    );
  };
  const [Registers, setRegisters] = useStateCallback(false);
  const handleRegister = () => {
    setRegisters(false, () =>
      setRegisters(<RegisterFuelCategoryModal func={fetchFuel_categories} />)
    );
  };
  const filteredActions = [
    {
      label: "card view",
      icon: "fa-regular fa-address-card",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("card view"),
    },
    {
      label: "table view",
      icon: "fa-solid fa-table",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("table view"),
    },
    {
      label: "Register Category",
      icon: "fa-solid fa-file-pen",
      className: "btn btn-info btn-sm",
      onClick: () => handleRegister(),
    },
  ].filter((action) => action.label !== viewType);
  <i class="fa-regular fa-address-card"></i>;
  return (
    <AppContainer
      title="Fuel Categories"
      previousPageTitle="Dashboard"
      actions={filteredActions}
    >
      <div className="container-fluid">
        <Toaster />
        {update}
        {Registers}
        {/* Loading / No Data */}
        {loading ? (
          <div className="text-center my-5 fs-5 text-muted">
            Loading Fuel categories...
          </div>
        ) : Fuel_categories.length === 0 ? (
          <div className="text-center my-5 fs-5 text-muted">
            No Fuel categories
          </div>
        ) : viewType === "table view" ? (
          <>
            <div className="row">
              <div className="col-sm-12 col-xl-12 col-lg-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <div>
                      <h6 className="card-title mb-1">Fuel Categories</h6>
                      <p className="text-muted card-sub-title">
                        List of registered Categories
                      </p>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-bordered text-nowrap mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Fuel Category</th>
                            <th>Station</th>
                            <th>Status</th>
                            <th>Created At</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(Fuel_categories) &&
                            Fuel_categories.map((cat, index) => (
                              <tr key={cat.id}>
                                <td>{index + 1}</td>
                                <td>{cat.fuel_category}</td>
                                <td>{cat.station_name}</td>
                                <td>
                                  <span
                                    className={`badge ${
                                      cat.status === "1"
                                        ? "bg-success"
                                        : "bg-danger"
                                    }`}
                                  >
                                    {cat.status === "1" ? "Active" : "Inactive"}
                                  </span>
                                </td>
                                <td>{cat.created_at}</td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-info"
                                    onClick={() => handleViewDetails(cat)}
                                  >
                                    <i className="fe fe-edit-2"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="row">
              {Fuel_categories.map((station) => (
                <div className="col-md-4 col-lg-3 mb-3" key={station.id}>
                  <div
                    className="card h-100"
                    style={{
                      borderRadius: "12px",
                      boxShadow: "4px 4px 12px rgba(0,0,0,0.1)",
                    }}
                  >
                    <div className="card-body text-center">
                      <h6 className="mb-1">{station.station_name}</h6>
                      <small className="d-block text-muted">
                        Fuel Category : {station.fuel_category}
                      </small>

                      <small className="d-block text-muted">
                        Created: {station.created_at}
                      </small>
                      <div className="mt-2">
                        <span
                          className={`badge px-3 py-1 ${
                            station.status === "1" ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {station.status === "1" ? "Active" : "Inactive"}
                        </span>
                      </div>
                      <div className="d-flex justify-content-center mt-3">
                        <button
                          className="btn btn-sm btn-outline-primary px-3"
                          onClick={() => handleViewDetails(station)}
                        >
                          <i className="fe fe-edit-2"></i> Edit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </AppContainer>
  );
};
export default ViewFuelCategories;
